export const reviewsOptions = [
  { 
    id: 1,
    label: 'Ver somente com depoimentos',
  },
  { 
    id: 2,
    label: 'Ver todas as avaliações'
  },
]